import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue";
const _hoisted_1 = {
  id: "phone-menu-container"
};
const _hoisted_2 = {
  class: "phone-container-w"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "menu-title"
};
import { ref } from 'vue';
import { iconMapping } from '@/constant/icon/phone_menu';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/Object.assign({
  name: 'PhoneMenu'
}, {
  __name: 'index',
  props: {
    // 导航栏开关
    isShowNav: {
      type: Boolean,
      default: false
    }
  },
  emits: ['e-change-router'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;

    // 导航栏列表
    const navList = ref([]);
    // 路由数据源
    const menuSourceList = ref([...router.options.routes.filter(route => route.name === 'common')[0].children.filter(item => item.name !== 'detail' && !item.redirect)]);
    // 格式化
    menuSourceList.value.forEach(item => {
      navList.value.push({
        path: item.path,
        title: item.meta.title,
        icon: item.meta.icon
      });
    });
    const emits = __emit;
    // 事件函数-路由切换
    const routerChangeHandle = path => {
      router.push(path);
      emits('e-change-router');
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createBlock(_Transition, {
        name: "fade",
        "enter-active-class": "animate__animated animate__fadeIn",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, menu => {
          return _openBlock(), _createElementBlock("li", {
            key: menu.title,
            class: _normalizeClass(_unref(route).path === menu.path ? 'item-active' : ''),
            onClick: $event => routerChangeHandle(menu.path)
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(iconMapping)[menu.icon])))]),
            _: 2
          }, 1024), _createElementVNode("div", _hoisted_4, _toDisplayString(menu.title), 1)], 10, _hoisted_3);
        }), 128))])], 512), [[_vShow, __props.isShowNav]])]),
        _: 1
      });
    };
  }
});